import { DEAL_TYPES, PROMO_CODE_TYPES } from '../../../../../services/exports/Constants';

export default {
  title: 'Speciale aanbiedingen',
  view_more: 'Meer bekijken',
  badges: {
    PROMO: 'Promo',
    DEAL: 'Deal',
    'FREE ITEM': 'Gratis item',
    REWARDS: 'Beloningen',
  },
  deals: {
    [DEAL_TYPES.GOOGLE_REVIEW_PROGRAM]: {
      title: '+{{reward}} extra punten',
      description: 'Beoordeel ons op Google',
    },
    [DEAL_TYPES.SMART_PRICING_RULE]: {
      title: 'Speciaal aanbod',
      description: 'Al automatisch toegepast',
    },
    buttons: {
      add: 'Toevoegen',
      remove: 'Verwijderen',
      show_details: 'Details tonen',
    },
    mobile_app_signup_bonus: {
      title: '{{amount}} App-aanmeldbonus',
      desc: 'Ontvang {{amount}} cashback wanneer je inlogt in onze app.',
    },
    welcome_bonus: {
      title: '{{amount}} Welkomstbonus',
      desc: 'Ontvang {{amount}} cashback wanneer je je registreert.',
    },
  },
  discounts: {
    title: '{{discount}} korting',
    usage_threshold: '(Min: {{amount}})',
    description: {
      [PROMO_CODE_TYPES.ONE_TIME_PROMO_CODE]: '{{discount}} korting op je volgende bestelling - code: {{code}}',
      [PROMO_CODE_TYPES.MULTI_PROMO_CODE]:
        '{{discount}} korting op je volgende {{count}} bestellingen - code: {{code}}',
    },
  },
  feedback: {
    login:
      '<highlight>Log in</highlight> om deze promo te gebruiken zodat we kunnen controleren of je hem nog niet hebt gebruikt. Log in en probeer opnieuw.',
  },
};
